import { BaseError } from "./BaseError";

export class UnauthorizedError extends BaseError {
  readonly status = 401;
}
